<template>
  <div v-if="releases" class="gp-content">
    <content-nav-bar>
      <a
        v-if="refresh"
        @click="refresh"
        class="level-item">
        <svgicon name="refresh" height="25" width="25"></svgicon>
      </a>
      <router-link class="level-item button add" :to="{ name: 'admin.releases.index.create' }">
        <i class="fas fa-plus"></i>
        Create Release
      </router-link>
    </content-nav-bar>
    <releases-table
      v-if="releases"
      :releases="releases.items">
    </releases-table>
  </div>
</template>

<script>
import ReleasesTable from '@/components/admin/releases/ReleasesTable.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'ReleasesList',
  components: {
    ReleasesTable,
    ContentNavBar,
  },
  async mounted() {
    this.refresh();
  },
  data() {
    return {
      releases: null,
    };
  },
  methods: {
    async refresh() {
      this.releases = await this.$store.dispatch('admin/listReleases');
    },
    async toggleRelease(id) {
      console.log(`Release ${id}`);
    },
  },
};
</script>
